import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const SplashCard = ({ isMobile, maxWidth, children }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: isMobile ? 380 : maxWidth,
        backgroundColor: theme.palette.primary.white,
        borderRadius: theme.shape.customBorderRadius[1],
        boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.1)',
        padding: isMobile ? '20px' : '56px 28px 28px 28px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
      }}
    >
      {children}
    </Box>
  );
};

export default SplashCard;
